import { Flex, VStack } from '@chakra-ui/react'
import { useState,useEffect } from 'react'
import { useParams,useLocation } from 'react-router-dom'
import TeamTable from '../../../components/tables/TeamTable'
import WorkforceOrganizationTable from '../../../components/tables/WorkforceOrganizationTable'

const OrganizationPage = () => {
  const location = useLocation()
  const [selectedTab, setSelectedTab] = useState('myTeams')
  const [isScrolled, setIsScrolled] = useState(false)
  const [page, setPage] = useState(1)

  useEffect(() => {
    if (location.pathname.includes('/organization/organization')) {
      setSelectedTab('organization')
    } else {
      setSelectedTab('myTeams')
    }
  }, [location.pathname])

  const renderTable = () => {
    switch (selectedTab) {
      case 'myTeams':
        return <TeamTable setData={() => {}} isUserMode={true} />
      case 'organization':
        return <WorkforceOrganizationTable />
      default:
        return <TeamTable setData={() => {}} isUserMode={true} />
    }
  }

  const handleScroll = (event: React.UIEvent<HTMLDivElement>) => {
    setIsScrolled(event.currentTarget.scrollTop > 0)
  }

  return (
    <Flex
      flexDirection={{ base: 'column', md: 'row' }}
      height="100%"
      overflowY="auto"
      onScroll={handleScroll}
      borderRadius={isScrolled ? '10px' : '0'}
    >
      <VStack gap={{ base: '12px', md: '16px' }} width="100%" flex="1">
        {renderTable()}
      </VStack>
    </Flex>
  )
}

export default OrganizationPage
